module.exports = __webpack_public_path__ + "Roboto-BoldItalic.a7dce23c0dd99a4afa5c.woff";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BoldItalic.woff
// module chunks = 16